import seoMetaData from '../data/seo-meta-data.json';

export interface SeoMetaData {
  title: string;
  description: string;
}

class SeoMetaUtil {
  private data: SeoMetaData[] = seoMetaData;
  private filteredData: SeoMetaData[] = [];

  constructor() {
    this.filteredData = this.data.filter(item => {
      const titleLower = item.title.toLowerCase();
      const descriptionLower = item.description.toLowerCase();
      return !titleLower.includes('leak') && !descriptionLower.includes('leak');
    });
  }

  public getRandomSeoMeta(username?: string, name?: string): SeoMetaData {
    if (!this.filteredData || this.filteredData.length === 0) {
      return {
        title: 'Twizz - Plateforme de contenu exclusif',
        description: 'Découvrez du contenu exclusif sur Twizz',
      };
    }

    // Filter titles that will not exceed 60 characters after placeholder replacement
    const validTitles = this.filterByTitleLength(username, name);

    if (validTitles.length === 0) {
      // Fallback: use a short generic title if no valid title found
      const creatorName = name || username || 'Créateur';
      return {
        title: `${creatorName} | Twizz`,
        description: `Découvrez le contenu exclusif de ${creatorName} sur Twizz.`,
      };
    }

    const randomIndex = this.getConsistentRandomIndex(username, validTitles.length);
    const selectedMeta = validTitles[randomIndex];

    return this.replacePlaceholders(selectedMeta, username, name);
  }

  private replacePlaceholders(meta: SeoMetaData, username?: string, name?: string): SeoMetaData {
    const creatorName = name || username || 'Créateur';
    const creatorUsername = username || 'username';

    let title = meta.title;
    let description = meta.description;

    // Pour les titles : on supprime (#name1) quand il suit #name pour éviter les doublons
    title = title.replace(/#name \(#name1\)/g, creatorUsername);
    title = title.replace(/#name1/g, creatorUsername);
    title = title.replace(/#name/g, creatorUsername);

    // Pour les descriptions : si #name et (#name1) se suivent ET sont identiques, on affiche qu'une fois
    if (creatorName === creatorUsername) {
      // Si les deux sont identiques, on remplace #name (#name1) par une seule occurrence
      description = description.replace(/#name \(#name1\)/g, creatorName);
    } else {
      // Si les deux sont différents, on garde les deux noms
      description = description.replace(/#name \(#name1\)/g, `${creatorName} ${creatorUsername}`);
    }
    description = description.replace(/#name1/g, creatorUsername);
    description = description.replace(/#name/g, creatorName);

    return {
      title,
      description,
    };
  }

  private filterByTitleLength(username?: string, name?: string): SeoMetaData[] {
    const MAX_TITLE_LENGTH = 60;
    const creatorUsername = username || 'username';

    return this.filteredData.filter(meta => {
      let simulatedTitle = meta.title;
      // Même logique que replacePlaceholders : on utilise uniquement username dans les titles
      simulatedTitle = simulatedTitle.replace(/#name \(#name1\)/g, creatorUsername);
      simulatedTitle = simulatedTitle.replace(/#name1/g, creatorUsername);
      simulatedTitle = simulatedTitle.replace(/#name/g, creatorUsername);

      return simulatedTitle.length <= MAX_TITLE_LENGTH;
    });
  }

  private getConsistentRandomIndex(username?: string, arrayLength?: number): number {
    const length = arrayLength || this.filteredData.length;
    
    if (!username) {
      return Math.floor(Math.random() * length);
    }

    let hash = 0;
    for (let i = 0; i < username.length; i++) {
      const char = username.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }

    return Math.abs(hash) % length;
  }

  public getTotalCount(): number {
    return this.filteredData.length;
  }
}

export const seoMetaUtil = new SeoMetaUtil();
